/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 848:
/***/ (function(module) {

/**
 * Get an array of an HTML elements classes
 * @param {HTMLElement} element
 * @returns {string[]} string array of class names
 */
var getClasses = function getClasses(element) {
  // Return without error if element or class are missing
  if (!element) return [];
  return element.className.split(' ').filter(Boolean);
};

/**
 * Does a class exist on an element
 * @param {HTMLElement} element
 * @returns {Boolean} true if element has class
 */
var hasClass = function hasClass(element, className) {
  // Return without error if element or class are missing
  if (!element || !className) return false;
  return getClasses(element).includes(className);
};

/**
 * Remove a class on a HTML element
 * @param {HTMLElement} element
 * @param {string} className
 */
var removeClass = function removeClass(element, className) {
  // Return without error if element or class are missing
  if (!element || !className) return;
  if (hasClass(element, className)) {
    // Array of all existing classes
    var existingClasses = getClasses(element);
    // String of existing classes minus the class to remove
    var newClasses = existingClasses.filter(function (existingClass) {
      return existingClass !== className;
    }).join(' ');
    // Set class attribute to the new classes
    element.setAttribute('class', newClasses);
  }
};

/**
 * Add a class on a HTML element
 * @param {HTMLElement} element
 * @param {string} className
 */
var addClass = function addClass(element, className) {
  // Return without error if element or class are missing
  if (!element || !className) return;
  if (!hasClass(element, className)) {
    // Set class attribute to the new classes
    element.setAttribute('class', (element.className + " " + className).trim());
  }
};

/**
 * Toggle a class on a HTML element
 * @param {HTMLElement} element
 * @param {string} className
 */
var toggleClass = function toggleClass(element, className) {
  if (!element || !className) return;
  if (hasClass(element, className)) {
    removeClass(element, className);
  } else {
    addClass(element, className);
  }
};

/**
 * Toggle a boolean attribute on a HTML element
 * @param {HTMLElement} element
 * @param {string} attr
 */
var toggleAttribute = function toggleAttribute(element, attr) {
  // Return without error if element or attr are missing
  if (!element || !attr) return;
  // Toggle attribute value. Treat no existing attr same as when set to false
  var value = element.getAttribute(attr) === 'true' ? 'false' : 'true';
  element.setAttribute(attr, value);
};

/**
 * Toggle a toggle a class on conditional content for an input based on checked state
 * @param {HTMLElement} input input element
 * @param {string} className class to toggle
 */
var toggleConditionalInput = function toggleConditionalInput(input, className) {
  // Return without error if input or class are missing
  if (!input || !className) return;
  // If the input has conditional content it had a data-aria-controls attribute
  var conditionalId = input.getAttribute('aria-controls');
  if (conditionalId) {
    // Get the conditional element from the input data-aria-controls attribute
    var conditionalElement = document.getElementById(conditionalId);
    if (conditionalElement) {
      if (input.checked) {
        conditionalElement.classList.remove(className);
      } else {
        conditionalElement.classList.add(className);
      }
    }
  }
};

/**
 * Move focus to element
 *
 * Sets tabindex to -1 to make the element programmatically focusable,
 * but removes it on blur as the element doesn't need to be focused again.
 *
 * Original code taken from GDS (Government Digital Service)
 * {@link https://github.com/alphagov/govuk-frontend}
 *
 * @template {HTMLElement} FocusElement
 * @param {FocusElement} $element - HTML element
 * @param {object} [options] - Handler options
 * @param {function(this: FocusElement): void} [options.onBeforeFocus] - Callback before focus
 * @param {function(this: FocusElement): void} [options.onBlur] - Callback on blur
 */
function setFocus($element, options) {
  if (options === void 0) {
    options = {};
  }
  var isFocusable = $element.getAttribute('tabindex');
  if (!isFocusable) {
    $element.setAttribute('tabindex', '-1');
  }

  /**
   * Handle element focus
   */
  function onFocus() {
    $element.removeEventListener('focus', onFocus);
    $element.addEventListener('blur', onBlur);
  }

  /**
   * Handle element blur
   */
  function onBlur() {
    $element.removeEventListener('blur', onBlur);
    if (options.onBlur) {
      options.onBlur.call($element);
    }
    if (!isFocusable) {
      $element.removeAttribute('tabindex');
    }
  }

  // Add listener to reset element on blur, after focus
  $element.addEventListener('focus', onFocus);

  // Focus element
  if (options.onBeforeFocus) {
    options.onBeforeFocus.call($element);
  }
  $element.focus();
}
module.exports = {
  toggleClass: toggleClass,
  toggleAttribute: toggleAttribute,
  toggleConditionalInput: toggleConditionalInput,
  setFocus: setFocus
};

/***/ }),

/***/ 997:
/***/ (function(module) {

var CharacterCount = /*#__PURE__*/function () {
  function CharacterCount($module) {
    this.$module = $module;
    this.$textarea = $module.querySelector('.hse-js-character-count');
    this.$visibleCountMessage = null;
    this.$screenReaderCountMessage = null;
    this.lastInputTimestamp = null;
  }

  // Initialize component
  var _proto = CharacterCount.prototype;
  _proto.init = function init() {
    // Check that required elements are present
    if (!this.$textarea) {
      return;
    }

    // Check for module
    var $module = this.$module;
    var $textarea = this.$textarea;
    var $fallbackLimitMessage = document.getElementById($textarea.id + "-info");

    // Move the fallback count message to be immediately after the textarea
    // Kept for backwards compatibility
    $textarea.insertAdjacentElement('afterend', $fallbackLimitMessage);

    // Create the *screen reader* specific live-updating counter
    // This doesn't need any styling classes, as it is never visible
    var $screenReaderCountMessage = document.createElement('div');
    $screenReaderCountMessage.className = 'hse-character-count__sr-status hse-u-visually-hidden';
    $screenReaderCountMessage.setAttribute('aria-live', 'polite');
    this.$screenReaderCountMessage = $screenReaderCountMessage;
    $fallbackLimitMessage.insertAdjacentElement('afterend', $screenReaderCountMessage);

    // Create our live-updating counter element, copying the classes from the
    // fallback element for backwards compatibility as these may have been configured
    var $visibleCountMessage = document.createElement('div');
    $visibleCountMessage.className = $fallbackLimitMessage.className;
    $visibleCountMessage.classList.add('hse-character-count__status');
    $visibleCountMessage.setAttribute('aria-hidden', 'true');
    this.$visibleCountMessage = $visibleCountMessage;
    $fallbackLimitMessage.insertAdjacentElement('afterend', $visibleCountMessage);

    // Hide the fallback limit message
    $fallbackLimitMessage.classList.add('hse-u-visually-hidden');

    // Read options set using dataset ('data-' values)
    this.options = CharacterCount.getDataset($module);

    // Determine the limit attribute (characters or words)
    var countAttribute = this.defaults.characterCountAttribute;
    if (this.options.maxwords) {
      countAttribute = this.defaults.wordCountAttribute;
    }

    // Save the element limit
    this.maxLength = $module.getAttribute(countAttribute);

    // Check for limit
    if (!this.maxLength) {
      return;
    }

    // Remove hard limit if set
    $textarea.removeAttribute('maxlength');
    this.bindChangeEvents();

    // When the page is restored after navigating 'back' in some browsers the
    // state of the character count is not restored until *after* the DOMContentLoaded
    // event is fired, so we need to manually update it after the pageshow event
    // in browsers that support it.
    if ('onpageshow' in window) {
      window.addEventListener('pageshow', this.updateCountMessage.bind(this));
    } else {
      window.addEventListener('DOMContentLoaded', this.updateCountMessage.bind(this));
    }
    this.updateCountMessage();
  }

  // Read data attributes
;
  CharacterCount.getDataset = function getDataset(element) {
    var dataset = {};
    var attributes = element.attributes;
    if (attributes) {
      for (var i = 0; i < attributes.length; i++) {
        var attribute = attributes[i];
        var match = attribute.name.match(/^data-(.+)/);
        if (match) {
          dataset[match[1]] = attribute.value;
        }
      }
    }
    return dataset;
  }

  // Counts characters or words in text
;
  _proto.count = function count(text) {
    var length;
    if (this.options.maxwords) {
      var tokens = text.match(/\S+/g) || []; // Matches consecutive non-whitespace chars
      length = tokens.length; // eslint-disable-line prefer-destructuring
    } else {
      length = text.length; // eslint-disable-line prefer-destructuring
    }
    return length;
  }

  // Bind input propertychange to the elements and update based on the change
;
  _proto.bindChangeEvents = function bindChangeEvents() {
    var $textarea = this.$textarea;
    $textarea.addEventListener('keyup', this.handleKeyUp.bind(this));

    // Bind focus/blur events to start/stop polling
    $textarea.addEventListener('focus', this.handleFocus.bind(this));
    $textarea.addEventListener('blur', this.handleBlur.bind(this));
  }

  // Speech recognition software such as Dragon NaturallySpeaking will modify the
  // fields by directly changing its `value`. These changes don't trigger events
  // in JavaScript, so we need to poll to handle when and if they occur.
;
  _proto.checkIfValueChanged = function checkIfValueChanged() {
    if (!this.$textarea.oldValue) {
      this.$textarea.oldValue = '';
    }
    if (this.$textarea.value !== this.$textarea.oldValue) {
      this.$textarea.oldValue = this.$textarea.value;
      this.updateCountMessage();
    }
  }

  // Helper function to update both the visible and screen reader-specific
  // counters simultaneously (e.g. on init)
;
  _proto.updateCountMessage = function updateCountMessage() {
    this.updateVisibleCountMessage();
    this.updateScreenReaderCountMessage();
  }

  // Update visible counter
;
  _proto.updateVisibleCountMessage = function updateVisibleCountMessage() {
    var $textarea = this.$textarea;
    var $visibleCountMessage = this.$visibleCountMessage;
    var remainingNumber = this.maxLength - this.count($textarea.value);

    // If input is over the threshold, remove the disabled class which renders the
    // counter invisible.
    if (this.isOverThreshold()) {
      $visibleCountMessage.classList.remove('hse-character-count__message--disabled');
    } else {
      $visibleCountMessage.classList.add('hse-character-count__message--disabled');
    }

    // Update styles
    if (remainingNumber < 0) {
      $textarea.classList.add('hse-textarea--error');
      $visibleCountMessage.classList.remove('hse-hint');
      $visibleCountMessage.classList.add('hse-error-message');
    } else {
      $textarea.classList.remove('hse-textarea--error');
      $visibleCountMessage.classList.remove('hse-error-message');
      $visibleCountMessage.classList.add('hse-hint');
    }

    // Update message
    $visibleCountMessage.innerHTML = this.formattedUpdateMessage();
  }

  // Update screen reader-specific counter
;
  _proto.updateScreenReaderCountMessage = function updateScreenReaderCountMessage() {
    var $screenReaderCountMessage = this.$screenReaderCountMessage;

    // If over the threshold, remove the aria-hidden attribute, allowing screen
    // readers to announce the content of the element.
    if (this.isOverThreshold()) {
      $screenReaderCountMessage.removeAttribute('aria-hidden');
    } else {
      $screenReaderCountMessage.setAttribute('aria-hidden', true);
    }

    // Update message
    $screenReaderCountMessage.innerHTML = this.formattedUpdateMessage();
  }

  // Format update message
;
  _proto.formattedUpdateMessage = function formattedUpdateMessage() {
    var $textarea = this.$textarea;
    var options = this.options;
    var remainingNumber = this.maxLength - this.count($textarea.value);
    var charVerb = 'remaining';
    var charNoun = 'character';
    var displayNumber = remainingNumber;
    if (options.maxwords) {
      charNoun = 'word';
    }
    charNoun += remainingNumber === -1 || remainingNumber === 1 ? '' : 's';
    charVerb = remainingNumber < 0 ? 'too many' : 'remaining';
    displayNumber = Math.abs(remainingNumber);
    return "You have " + displayNumber + " " + charNoun + " " + charVerb;
  }

  // Checks whether the value is over the configured threshold for the input.
  // If there is no configured threshold, it is set to 0 and this function will
  // always return true.
;
  _proto.isOverThreshold = function isOverThreshold() {
    var $textarea = this.$textarea;
    var options = this.options;

    // Determine the remaining number of characters/words
    var currentLength = this.count($textarea.value);
    var maxLength = this.maxLength;

    // Set threshold if presented in options
    var thresholdPercent = options.threshold ? options.threshold : 0;
    var thresholdValue = maxLength * thresholdPercent / 100;
    return thresholdValue <= currentLength;
  }

  // Update the visible character counter and keep track of when the last update
  // happened for each keypress
;
  _proto.handleKeyUp = function handleKeyUp() {
    this.updateVisibleCountMessage();
    this.lastInputTimestamp = Date.now();
  };
  _proto.handleFocus = function handleFocus() {
    var _this = this;
    // If the field is focused, and a keyup event hasn't been detected for at
    // least 1000 ms (1 second), then run the manual change check.
    // This is so that the update triggered by the manual comparison doesn't
    // conflict with debounced KeyboardEvent updates.
    this.valueChecker = setInterval(function () {
      if (!_this.lastInputTimestamp || Date.now() - 500 >= _this.lastInputTimestamp) {
        _this.checkIfValueChanged();
      }
    }, 1000);
  };
  _proto.handleBlur = function handleBlur() {
    // Cancel value checking on blur
    clearInterval(this.valueChecker);
  };
  return CharacterCount;
}();
CharacterCount.prototype.defaults = {
  characterCountAttribute: 'data-maxlength',
  wordCountAttribute: 'data-maxwords'
};
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var characterCounts = scope.querySelectorAll('[data-module="hse-character-count"]');
  characterCounts.forEach(function (el) {
    new CharacterCount(el).init();
  });
};

/***/ }),

/***/ 305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleConditionalInput = _require.toggleConditionalInput;

/**
 * Conditionally show content when a checkbox button is checked
 * Test at http://localhost:3001/hse-frontend/components/checkboxes/conditional.html
 */
var syncAllConditionalReveals = function syncAllConditionalReveals(input) {
  var allInputsInForm = input.form.querySelectorAll('input[type="checkbox"]');
  allInputsInForm.forEach(function (item) {
    return toggleConditionalInput(item, 'hse-checkboxes__conditional--hidden');
  });
};

/**
 * Uncheck other checkboxes
 *
 * Find any other checkbox inputs with the checkbox group value, and uncheck them.
 * This is useful for when a “None of these" checkbox is checked.
 */
var unCheckAllInputsExcept = function unCheckAllInputsExcept(input) {
  var allInputsInSameExclusiveGroup = input.form.querySelectorAll("input[type=\"checkbox\"][data-checkbox-exclusive-group=\"" + input.getAttribute('data-checkbox-exclusive-group') + "\"]");
  allInputsInSameExclusiveGroup.forEach(function (inputWithSameName) {
    var hasSameFormOwner = input.form === inputWithSameName.form;
    if (hasSameFormOwner && inputWithSameName !== input) {
      inputWithSameName.checked = false; // eslint-disable-line no-param-reassign
    }
  });
  syncAllConditionalReveals(input);
};

/**
 * Uncheck exclusive inputs
 *
 * Find any checkbox inputs with the same checkbox group value and the 'exclusive' behaviour,
 * and uncheck them. This helps prevent someone checking both a regular checkbox and a
 * "None of these" checkbox in the same fieldset.
 */
var unCheckExclusiveInputs = function unCheckExclusiveInputs(input) {
  var allExclusiveInputsInSameExclusiveGroup = input.form.querySelectorAll("input[type=\"checkbox\"][data-checkbox-exclusive][data-checkbox-exclusive-group=\"" + input.getAttribute('data-checkbox-exclusive-group') + "\"]");
  allExclusiveInputsInSameExclusiveGroup.forEach(function (exclusiveInput) {
    var hasSameFormOwner = input.form === exclusiveInput.form;
    if (hasSameFormOwner) {
      exclusiveInput.checked = false; // eslint-disable-line no-param-reassign
    }
  });
  syncAllConditionalReveals(input);
};
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Checkbox input DOMElements inside a conditional form group
  var checkboxInputs = scope.querySelectorAll('.hse-checkboxes .hse-checkboxes__input');

  /**
   * Toggle classes and attributes
   * @param {Object} event click event object
   */
  var handleClick = function handleClick(event) {
    // Toggle conditional content based on checked state
    toggleConditionalInput(event.target, 'hse-checkboxes__conditional--hidden');
    if (!event.target.checked) {
      return;
    }

    // Handle 'exclusive' checkbox behaviour (ie "None of these")
    if (event.target.hasAttribute('data-checkbox-exclusive')) {
      unCheckAllInputsExcept(event.target);
    } else {
      unCheckExclusiveInputs(event.target);
    }
  };

  // When the page is restored after navigating 'back' in some browsers the
  // state of form controls is not restored until *after* the DOMContentLoaded
  // event is fired, so we need to sync after the pageshow event in browsers
  // that support it.
  if ('onpageshow' in window) {
    window.addEventListener('pageshow', function () {
      return checkboxInputs.forEach(function (input) {
        return syncAllConditionalReveals(input);
      });
    });
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      return checkboxInputs.forEach(function (input) {
        return syncAllConditionalReveals(input);
      });
    });
  }

  // Although we've set up handlers to sync state on the pageshow or
  // DOMContentLoaded event, init could be called after those events have fired,
  // for example if they are added to the page dynamically, so sync now too.
  checkboxInputs.forEach(function (input) {
    return syncAllConditionalReveals(input);
  });

  // Attach handleClick as click to checkboxInputs
  checkboxInputs.forEach(function (checkboxButton) {
    checkboxButton.addEventListener('change', handleClick);
  });
};

/***/ }),

/***/ 365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var keyboardState = __webpack_require__(855);
var _require = __webpack_require__(1),
  normalize = _require.normalize;
var ANNOUNCE_DEBOUNCE_MS = 400;
var Combobox = /*#__PURE__*/function () {
  function Combobox($module) {
    this.$module = $module;
    this.$input = $module.querySelector('.hse-combobox__input');
    this.$field = $module.querySelector('.hse-combobox__field');
    this.$clearButton = $module.querySelector('.hse-combobox__clear');
    this.$toggleButton = $module.querySelector('.hse-combobox__toggle');
    this.$listbox = $module.querySelector('.hse-combobox__listbox');
    this.$noResults = $module.querySelector('.hse-combobox__no-results');
    this.$status = $module.querySelector('[role="status"]');
    this.$error = $module.querySelector('.hse-error-message');
    this.$formGroup = $module.querySelector('.hse-form-group');
  }
  var _proto = Combobox.prototype;
  _proto.init = function init() {
    if (!this.$input || !this.$listbox) {
      return;
    }
    this.match = this.$module.dataset.match || 'start';
    this.minChars = Number(this.$module.dataset.minChars) || 1;
    this.errorNotInList = this.$module.dataset.errorNotInList;
    // Runtime announcement strings, translatable the same way as every other
    // combobox string (errorNotInList, noResultsText, ...) but read via data
    // attribute rather than rendered text, since each needs a value
    // interpolated at announce time, not fixed at page load.
    this.resultsOneText = this.$module.dataset.resultsOne || '%{count} result available';
    this.resultsOtherText = this.$module.dataset.resultsOther || '%{count} results available';
    this.selectedText = this.$module.dataset.selected || '%{option} selected';
    // A bare word, matching the server-rendered error-message component's
    // own visuallyHiddenText convention - the colon is appended wherever
    // this is actually used, not stored here.
    this.errorPrefix = this.$module.dataset.errorPrefix || 'Error';
    // Derived from which buttons the template rendered, rather than a
    // separate context attribute duplicating information the markup
    // already carries.
    this.context = this.$toggleButton ? 'set-list' : this.$module.querySelector('.hse-combobox__search') ? 'search' : 'address';
    this.$optionElements = Array.from(this.$listbox.querySelectorAll('.hse-combobox__option'));
    this.options = this.$optionElements.map(function ($option) {
      return {
        id: $option.id,
        label: $option.textContent.trim()
      };
    });
    this.state = keyboardState.createInitialState();
    this.announceTimer = null;
    // The server-rendered error, if any - a form reset restores the value
    // that caused it, so it restores the error too.
    this.initialErrorHTML = this.$error && !this.$error.hidden ? this.$error.innerHTML : '';
    this.bindEvents();
    this.render();
  };
  _proto.bindEvents = function bindEvents() {
    var _this = this;
    this.$input.addEventListener('input', this.handleInput.bind(this));
    this.$input.addEventListener('keydown', this.handleKeydown.bind(this));
    this.$input.addEventListener('blur', this.handleFocusLeave.bind(this));
    // The browser fires its own 'change' on blur whenever the value differs
    // from when the input gained focus - after a selection, that repeats
    // the 'change' applyResult already sent for the same value. Bound first,
    // so it runs before any consumer listener on the input.
    this.$input.addEventListener('change', function (event) {
      if (event.isTrusted && _this.$input.value === _this.lastChangeValue) {
        event.stopImmediatePropagation();
      }
    });
    if (this.$clearButton) {
      // Keeps focus in the input on a pointer press, as the toggle and
      // listbox do - so a Clear click never blurs the input and can't be
      // mistaken for leaving the field, in browsers that focus a clicked
      // button and in those (Safari) that don't. Keyboard activation of
      // Clear is unaffected.
      this.$clearButton.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });
      this.$clearButton.addEventListener('click', this.handleClear.bind(this));
      // Tabbing on from Clear leaves the component just as tabbing on from
      // the input does - without this, the popup stays open over the next
      // field and the not-in-list check never runs.
      this.$clearButton.addEventListener('blur', this.handleFocusLeave.bind(this));
    }
    if (this.$toggleButton) {
      // Keeps focus in the input, as the listbox does below - otherwise the
      // input blurs on mousedown and the not-in-list error flashes (and is
      // announced) before the click re-opens the list.
      this.$toggleButton.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });
      this.$toggleButton.addEventListener('click', this.handleToggleClick.bind(this));
    }

    // Keeps focus in the input through a mouse selection (the APG combobox
    // pattern) - without this, mousedown on an option would blur the input
    // before 'click' has a chance to confirm the selection, both breaking
    // the "focus never leaves the input" invariant and spuriously tripping
    // the not-in-list validation on that same blur.
    this.$listbox.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });
    this.$listbox.addEventListener('click', this.handleOptionClick.bind(this));
    var $form = this.$input.closest('form');
    if ($form) {
      $form.addEventListener('submit', this.handleSubmit.bind(this));
      $form.addEventListener('reset', this.handleReset.bind(this));
    }
    window.addEventListener('resize', this.updatePosition.bind(this));
  };
  _proto.handleInput = function handleInput() {
    // Typed text is the user's own - the browser's 'change' on blur for it
    // is real, so stop treating it as a repeat of the last selection.
    this.lastChangeValue = null;
    this.state = keyboardState.onType(this.state, {
      query: this.$input.value,
      options: this.options,
      mode: this.match,
      minChars: this.minChars
    });
    // Per the tech approach, an error is removed when an option is chosen
    // or the field is cleared - not on every keystroke, which would hide it
    // while the value is still invalid.
    if (this.$input.value.length === 0) {
      this.clearError();
    }
    this.render();
    this.announceResultCount();
  };
  _proto.handleKeydown = function handleKeydown(event) {
    // Modifier combinations (Cmd+ArrowDown moves the caret, for example) and
    // keys pressed while an IME is composing text belong to the browser.
    if (event.altKey || event.ctrlKey || event.metaKey || event.isComposing) {
      return;
    }
    // A read-only or disabled value can't change - leave every key native
    // (no preventDefault), just closing a list left open from before it was
    // locked.
    if (this.isLocked()) {
      if (this.state.isOpen) {
        this.state = keyboardState.onEscape(this.state);
        this.render();
      }
      return;
    }
    var nextState;
    switch (event.key) {
      case 'ArrowDown':
        nextState = this.context === 'set-list' && this.state.matchCount === 0 ? keyboardState.onRequestFullList(this.state, {
          options: this.options
        }) : keyboardState.onArrowDown(this.state);
        break;
      case 'ArrowUp':
        nextState = keyboardState.onArrowUp(this.state);
        break;
      case 'Enter':
        nextState = keyboardState.onEnter(this.state);
        break;
      case 'Escape':
        nextState = keyboardState.onEscape(this.state);
        break;
      default:
        nextState = keyboardState.onUnhandledKey(this.state);
    }
    var _nextState = nextState,
      result = _nextState.result;

    // preventDefault() only when this component actually did something with
    // the key. Unhandled keys (Home, End, ...) keep their native behaviour,
    // Enter with nothing highlighted submits the form (handleSubmit still
    // blocks text that isn't an option), and Escape with nothing to close
    // or clear reaches an enclosing dialog.
    if (result.type !== 'unhandled' && result.type !== 'noop') {
      event.preventDefault();
    }

    // Unhandled means nothing changed - skip the render. Printable keys hit
    // this path too (they're not in the switch above), and the input's
    // own 'input' event already re-filters and re-renders right after.
    if (result.type !== 'unhandled') {
      this.applyResult(nextState);
    }
  }

  // Runs after the browser has restored the form's default values - 'reset'
  // fires before it does - and puts the component back as it loaded.
;
  _proto.handleReset = function handleReset(event) {
    var _this2 = this;
    setTimeout(function () {
      // A consumer cancelled the reset, so no values were restored either
      if (event.defaultPrevented) {
        return;
      }
      _this2.state = keyboardState.createInitialState();
      _this2.lastChangeValue = null;
      _this2.announceImmediately('');
      if (_this2.initialErrorHTML) {
        _this2.$error.hidden = false;
        _this2.$error.innerHTML = _this2.initialErrorHTML;
        _this2.setErrorState(true);
      } else {
        _this2.clearError();
      }
      _this2.render();
    });
  }

  // Disabled (including inside a disabled fieldset) or read-only - the
  // value can't change, so nothing in this component may change it either.
;
  _proto.isLocked = function isLocked() {
    return this.$input.matches(':disabled') || this.$input.readOnly;
  }

  // Runs when focus leaves the input or the clear button. Moving between
  // those two doesn't count as leaving (tech approach: "Moving to the clear
  // button doesn't count as leaving") - relatedTarget covers that.
;
  _proto.handleFocusLeave = function handleFocusLeave(event) {
    if (event.relatedTarget === this.$input || event.relatedTarget === this.$clearButton) {
      return;
    }
    // Leaving the component entirely should close the popup, same as the
    // first Escape press - otherwise it's left open and aria-expanded stays
    // "true" on a control that no longer has focus.
    if (this.state.isOpen) {
      this.state = keyboardState.onEscape(this.state);
      this.render();
    }
    // Cancels any pending result count, which would otherwise be read out
    // after focus has already moved to another field.
    this.announceImmediately('');
    this.validateNotInList({
      moveFocus: false
    });
  };
  _proto.handleClear = function handleClear() {
    if (this.isLocked()) {
      return;
    }
    this.$input.value = '';
    this.dispatchChange();
    this.state = keyboardState.onType(this.state, {
      query: '',
      options: this.options,
      mode: this.match,
      minChars: this.minChars
    });
    this.clearError();
    // Before render(), which hides Clear now the value is empty - focus
    // would otherwise drop to <body>, and the clear button's blur would see
    // no relatedTarget and treat it as leaving the component.
    this.$input.focus();
    this.render();
    this.announceImmediately('');
  };
  _proto.handleToggleClick = function handleToggleClick(event) {
    if (this.isLocked()) {
      return;
    }
    this.state = keyboardState.onRequestFullList(this.state, {
      options: this.options,
      // A real mouse click (event.detail >= 1) opens the list with focus
      // staying on the input, nothing pre-highlighted. Enter/Space on the
      // focused button also fires 'click', with event.detail === 0 - that
      // case keeps the same "highlight first" behaviour as ArrowDown, since
      // the user is already keyboard-driving and landing on the first
      // option is the expected, lower-friction continuation.
      highlightFirst: event.detail === 0
    });
    this.render();
    // Safari doesn't focus a clicked <button> by default - without this,
    // the arrow keys the user presses next wouldn't reach this component.
    this.$input.focus();
  };
  _proto.handleOptionClick = function handleOptionClick(event) {
    if (this.isLocked()) {
      return;
    }
    var $option = event.target.closest('.hse-combobox__option');
    if (!$option) {
      return;
    }
    var option = this.options.find(function (candidate) {
      return candidate.id === $option.id;
    });
    // The list can still be open with focus on Clear (moving to Clear
    // doesn't close it), and the listbox's mousedown keeps focus wherever it
    // was - so bring it back to the input, where the arrow keys work. Before
    // applyResult, so the focus readout doesn't cut off "X selected".
    if (document.activeElement !== this.$input) {
      this.$input.focus();
    }
    this.applyResult(keyboardState.onOptionClick(this.state, {
      option: option
    }));
  };
  _proto.handleSubmit = function handleSubmit(event) {
    // A locked value can't be fixed by the user (and a disabled one isn't
    // even submitted), so blocking the form on it would trap them.
    if (this.isLocked()) {
      return;
    }
    var value = this.$input.value;
    // Empty is left to the service's own required check, and without an
    // errorNotInList message there's no feedback to give - blocking either
    // would leave the form unsubmittable with nothing on screen to say why.
    if (this.context === 'search' || value.length === 0 || !this.errorNotInList || this.acceptExactMatch(value)) {
      return;
    }
    // Another combobox earlier in the same form already blocked this submit
    // and took focus - show this one's error but leave focus on the first.
    var moveFocus = !event.defaultPrevented;
    event.preventDefault();
    this.validateNotInList({
      moveFocus: moveFocus
    });
  }

  // Applies a transition's result (not just its state) - confirmations and
  // closes need side effects (writing the input value, announcing) beyond
  // what render() alone does from state.
;
  _proto.applyResult = function applyResult(nextState) {
    var result = nextState.result;
    this.state = nextState;
    if (result.type === 'confirmed') {
      this.$input.value = result.option.label;
      this.clearError();
    } else if (result.type === 'cleared') {
      // Second Escape after the list was dismissed - keyboard-state.js
      // already decided the value should clear, but writing it to the
      // input is this adapter's job, same as the 'confirmed' branch above.
      this.$input.value = '';
      this.clearError();
    }
    if (result.type === 'confirmed' || result.type === 'cleared') {
      this.dispatchChange();
    }
    this.render();
    if (result.type === 'confirmed') {
      this.announceImmediately(this.selectedText.replace('%{option}', result.option.label));
    } else if (result.type === 'highlighted') {
      this.announceResultCount();
    } else if (result.type === 'closed' || result.type === 'cleared') {
      // Nothing to count once the list is closed or the text is gone -
      // empties the region and cancels any count still pending.
      this.announceImmediately('');
    }
  }

  // Setting .value from script fires no events, so consumers listening for
  // 'change' would never see a selection or a clear. Not 'input' - that would
  // re-run handleInput and re-open the list filtered to the chosen label.
  // Records the value so the browser's own 'change' on the next blur, for
  // this same value, can be dropped as a repeat (see bindEvents).
;
  _proto.dispatchChange = function dispatchChange() {
    this.lastChangeValue = this.$input.value;
    this.$input.dispatchEvent(new Event('change', {
      bubbles: true
    }));
  };
  _proto.render = function render() {
    var state = this.state;
    var isOpen = state.isOpen;
    var isListboxShown = isOpen && state.status === 'hasMatches';

    // Tracks the listbox itself, not just "open" - with no matches only the
    // aria-hidden "No results found" copy shows, so "expanded" would point a
    // screen reader at a listbox it can't reach. The status region announces
    // the no-results case instead.
    this.$input.setAttribute('aria-expanded', String(isListboxShown));
    if (state.highlightedId) {
      this.$input.setAttribute('aria-activedescendant', state.highlightedId);
    } else {
      this.$input.removeAttribute('aria-activedescendant');
    }
    var matchedIds = new Set(state.matches.map(function (option) {
      return option.id;
    }));
    this.$optionElements.forEach(function ($option) {
      var isMatch = matchedIds.has($option.id);
      $option.hidden = !isMatch;
      var isHighlighted = $option.id === state.highlightedId;
      if (isHighlighted) {
        $option.setAttribute('aria-selected', 'true');
      } else {
        $option.removeAttribute('aria-selected');
      }
    });
    this.$listbox.hidden = !isListboxShown;
    if (this.$noResults) {
      this.$noResults.hidden = !(isOpen && state.status === 'noMatches');
    }
    if (this.$clearButton) {
      this.$clearButton.hidden = this.$input.value.length === 0;
    }

    // Before scrolling, so the page only ever scrolls to where the popup
    // finally sits - scrolling first could move the page to show an option
    // below the field, then flip the popup above it.
    if (isOpen) {
      this.updatePosition();
    }

    // Only once the listbox and its options are shown - a hidden element
    // measures as zero, so scrolling any earlier (for example re-opening
    // with Up Arrow straight onto the last option) would leave the
    // highlighted option out of view.
    if (isListboxShown && state.highlightedId) {
      this.scrollOptionIntoView(document.getElementById(state.highlightedId));
    }
  }

  // block: 'nearest' scrolls the listbox first and moves the page only as
  // far as it must - so a list that runs off screen (one that fits neither
  // below nor above the field) still brings the highlighted option into
  // view, and a consuming site's scroll-padding for a sticky header is
  // respected. Not implemented by jsdom, hence the guard.
;
  _proto.scrollOptionIntoView = function scrollOptionIntoView($option) {
    if (typeof $option.scrollIntoView === 'function') {
      $option.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }

  // Decides whether to flip the popup above the field, then leaves the
  // actual positioning to the `hse-combobox--above` CSS rule - no pixel
  // measurement needed, since the field is the popup's only in-flow sibling.
;
  _proto.updatePosition = function updatePosition() {
    if (!this.state.isOpen) {
      return;
    }
    var fieldRect = this.$field.getBoundingClientRect();
    var spaceBelow = window.innerHeight - fieldRect.bottom;
    var spaceAbove = fieldRect.top;
    // Measures whichever popup is showing (a filtered list is often much
    // shorter than its max-height). Flips only when it doesn't fit below but
    // does fit above - flipping a popup that fits neither way would push its
    // top off the page, where nobody can scroll to it.
    var $popup = this.$listbox.hidden ? this.$noResults : this.$listbox;
    var popupHeight = $popup ? $popup.offsetHeight : 0;
    var shouldFlip = spaceBelow < popupHeight && spaceAbove >= popupHeight;
    this.$module.classList[shouldFlip ? 'add' : 'remove']('hse-combobox--above');
  };
  _proto.findExactMatch = function findExactMatch(value) {
    var normalizedValue = normalize(value);
    return this.options.find(function (option) {
      return normalize(option.label) === normalizedValue;
    });
  }

  // Typing an option's text counts as choosing it, even with different
  // case, spacing or accents - so the input takes that option's own text,
  // which is what the form submits ("car diology" -> "Cardiology").
;
  _proto.acceptExactMatch = function acceptExactMatch(value) {
    var option = this.findExactMatch(value);
    if (!option) {
      return false;
    }
    // Confirmed like a list selection - the list closes (Enter can submit
    // with it open, and a page that handles submit itself stays put), and a
    // later single Escape can't wipe the value.
    this.state = keyboardState.onAcceptMatch(this.state, {
      option: option
    });
    if (option.label !== value) {
      this.$input.value = option.label;
      this.dispatchChange();
    }
    this.render();
    // Nothing left to count once the list is closed
    this.announceImmediately('');
    return true;
  };
  _proto.validateNotInList = function validateNotInList(_ref) {
    var moveFocus = _ref.moveFocus;
    var value = this.$input.value;
    // Search takes free text by design, so there's no "not in list" for it.
    if (this.isLocked() || this.context === 'search' || value.length === 0 || !this.errorNotInList) {
      return;
    }
    // Choosing an option by typing its text removes the error the same way
    // picking it from the list would.
    if (this.acceptExactMatch(value)) {
      this.clearError();
      return;
    }
    this.showError(this.errorNotInList);
    if (moveFocus && document.activeElement !== this.$input) {
      // Focus lands on the input, whose aria-describedby and aria-invalid
      // already read the error - announcing it as well would say it twice.
      this.$input.focus();
    } else {
      // Either focus has moved on to another field, or it was already in
      // this input (Enter submitted the form), so focus() changes nothing -
      // in both cases the description won't be read again, and the status
      // region is the only way to hear the error. Prefixed to match the
      // error message's own visually hidden prefix.
      this.announceImmediately(this.errorPrefix + ": " + this.getLabelText() + ": " + this.errorNotInList);
    }
  }

  // Names the field in announcements made when focus may be elsewhere, so
  // with two comboboxes in one form the user can tell which error is which.
;
  _proto.getLabelText = function getLabelText() {
    var $label = this.$module.querySelector('.hse-label');
    return $label ? $label.textContent.trim() : '';
  };
  _proto.showError = function showError(message) {
    if (this.$error) {
      this.$error.hidden = false;
      // Built here rather than relying on template-rendered markup - the
      // template leaves this span empty when there's no error (see
      // template.njk), since aria-describedby exposes a hidden element's
      // text to screen readers regardless of the `hidden` attribute.
      var $prefix = document.createElement('span');
      $prefix.className = 'hse-u-visually-hidden';
      $prefix.textContent = this.errorPrefix + ":";
      this.$error.textContent = '';
      this.$error.appendChild($prefix);
      this.$error.appendChild(document.createTextNode(" " + message));
    }
    this.setErrorState(true);
  };
  _proto.clearError = function clearError() {
    if (this.$error && !this.$error.hidden) {
      this.$error.hidden = true;
      // Emptied, not just hidden - otherwise the previous message stays in
      // the DOM and keeps being read out via aria-describedby (which
      // ignores `hidden`) on every future focus.
      this.$error.textContent = '';
      this.setErrorState(false);
    }
  }

  // Keeps the error styling (form-group bar, red field border) in step with
  // the message, matching what the template renders for a server-side error.
;
  _proto.setErrorState = function setErrorState(hasError) {
    // add/remove rather than toggle(name, force), which Safari 12 lacks.
    var method = hasError ? 'add' : 'remove';
    this.$module.classList[method]('hse-combobox--error');
    if (this.$formGroup) {
      this.$formGroup.classList[method]('hse-form-group--error');
    }
    if (hasError) {
      this.$input.setAttribute('aria-invalid', 'true');
    } else {
      this.$input.removeAttribute('aria-invalid');
    }
  };
  _proto.getResultMessage = function getResultMessage() {
    var _this$state = this.state,
      status = _this$state.status,
      matchCount = _this$state.matchCount;
    if (status === 'noMatches') {
      return this.$noResults ? this.$noResults.textContent.trim() : 'No results found';
    }
    if (status === 'hasMatches') {
      var template = matchCount === 1 ? this.resultsOneText : this.resultsOtherText;
      return template.replace('%{count}', matchCount);
    }
    return '';
  };
  _proto.announceResultCount = function announceResultCount() {
    var _this3 = this;
    clearTimeout(this.announceTimer);
    this.announceTimer = setTimeout(function () {
      _this3.writeStatus(_this3.getResultMessage());
    }, ANNOUNCE_DEBOUNCE_MS);
  };
  _proto.announceImmediately = function announceImmediately(message) {
    clearTimeout(this.announceTimer);
    this.writeStatus(message);
  };
  _proto.writeStatus = function writeStatus(message) {
    if (this.$status) {
      this.$status.textContent = message;
    }
  };
  return Combobox;
}();
module.exports = function (_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$scope = _ref2.scope,
    scope = _ref2$scope === void 0 ? document : _ref2$scope;
  // Browsers without these (IE11) keep the plain text input instead. Without
  // the check, Array.from throws in init() and stops every component after
  // this one in initAll() from initialising.
  if (typeof Array.from !== 'function' || typeof String.prototype.normalize !== 'function') {
    return;
  }
  var comboboxes = scope.querySelectorAll('[data-module="hse-combobox"]');
  comboboxes.forEach(function ($module) {
    // initAll(scope) can run again over content it has already seen - a
    // second instance would bind every listener twice.
    if ($module.dataset.comboboxInitialised) {
      return;
    }
    $module.dataset.comboboxInitialised = 'true';
    new Combobox($module).init();
  });
};
module.exports.Combobox = Combobox;

/***/ }),

/***/ 855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(1),
  filterOptions = _require.filterOptions;

// closeReason records *why* the list is closed, so a second Escape press can
// tell "the user dismissed the list" apart from "the user just confirmed a
// selection" - without this, Escape after a confirmed choice would silently
// wipe out the value the user just picked.
function createInitialState() {
  return {
    isOpen: false,
    highlightedId: null,
    highlightCleared: false,
    // see onArrowUp - tells "never arrowed yet" apart from "arrowed up past the first option"
    closeReason: null,
    // 'dismissed' | 'confirmed' | null
    matches: [],
    matchCount: 0,
    status: 'belowThreshold',
    lastConfirmedValue: null
  };
}

// Re-filters as the user types. Highlight always resets on re-filter: the
// list has conceptually changed, so nothing should stay "current" that the
// user didn't just choose themselves.
function onType(state, _ref) {
  var query = _ref.query,
    options = _ref.options,
    mode = _ref.mode,
    minChars = _ref.minChars;
  var _filterOptions = filterOptions({
      options: options,
      query: query,
      mode: mode,
      minChars: minChars
    }),
    status = _filterOptions.status,
    matches = _filterOptions.matches,
    matchCount = _filterOptions.matchCount;
  return Object.assign({}, state, {
    isOpen: status !== 'belowThreshold',
    highlightedId: null,
    highlightCleared: false,
    closeReason: null,
    // Typing over a confirmed value abandons it, so a later second Escape
    // may clear the text again.
    lastConfirmedValue: null,
    status: status,
    matches: matches,
    matchCount: matchCount
  });
}
function highlightIndex(state, index) {
  var option = state.matches[index];
  return Object.assign({}, state, {
    isOpen: true,
    highlightedId: option.id,
    highlightCleared: false,
    closeReason: null,
    result: {
      type: 'highlighted',
      option: option
    }
  });
}

// The "set list" context's expand button shows every option, bypassing the
// character threshold entirely - this is the down arrow's keyboard
// equivalent to that button, for the one context where it exists. The
// adapter must only call this (instead of onArrowDown) when the combobox has
// no match yet *and* its context is "set list" - address lookup and search
// have no "browse everything" affordance for a mouse user either, so there's
// no keyboard parity gap to fix for them.
function onRequestFullList(state, _ref2) {
  var options = _ref2.options,
    _ref2$highlightFirst = _ref2.highlightFirst,
    highlightFirst = _ref2$highlightFirst === void 0 ? true : _ref2$highlightFirst;
  if (options.length === 0) {
    return Object.assign({}, state, {
      result: {
        type: 'unhandled'
      }
    });
  }
  var opened = Object.assign({}, state, {
    isOpen: true,
    closeReason: null,
    status: 'hasMatches',
    matches: options,
    matchCount: options.length,
    highlightedId: null
  });
  if (!highlightFirst) {
    // A mouse click on the expand button opens the list with focus staying
    // on the input, nothing pre-highlighted - highlightCleared must still be
    // reset here (not just by highlightIndex below), or a stale `true` left
    // over from an earlier ArrowUp-past-the-first-option sequence would
    // wrongly suppress ArrowUp's jump-to-last-option on this freshly opened
    // list.
    return Object.assign({}, opened, {
      highlightCleared: false,
      result: {
        type: 'opened'
      }
    });
  }
  return highlightIndex(opened, 0);
}
function onArrowDown(state) {
  if (state.matchCount === 0) {
    return Object.assign({}, state, {
      result: {
        type: 'unhandled'
      }
    });
  }
  if (state.highlightedId === null) {
    return highlightIndex(state, 0);
  }
  var currentIndex = state.matches.findIndex(function (option) {
    return option.id === state.highlightedId;
  });
  var nextIndex = Math.min(currentIndex + 1, state.matches.length - 1);
  return highlightIndex(state, nextIndex);
}
function onArrowUp(state) {
  if (state.matchCount === 0) {
    return Object.assign({}, state, {
      result: {
        type: 'unhandled'
      }
    });
  }
  if (state.highlightedId === null) {
    if (state.highlightCleared) {
      // Already stepped up past the first option - stay there rather than
      // wrapping around to the last option again (no wrap, matches the
      // WAI-ARIA list-autocomplete pattern).
      return Object.assign({}, state, {
        result: {
          type: 'highlighted',
          option: null
        }
      });
    }
    return highlightIndex(state, state.matches.length - 1);
  }
  var currentIndex = state.matches.findIndex(function (option) {
    return option.id === state.highlightedId;
  });
  if (currentIndex === 0) {
    return Object.assign({}, state, {
      highlightedId: null,
      highlightCleared: true,
      result: {
        type: 'highlighted',
        option: null
      }
    });
  }
  return highlightIndex(state, currentIndex - 1);
}

// No-ops (rather than confirming nothing) when no option is highlighted, so
// a context where Enter submits the form - search - still gets a normal
// Enter keypress to work with.
function onEnter(state) {
  if (!state.isOpen || state.highlightedId === null) {
    return Object.assign({}, state, {
      result: {
        type: 'noop'
      }
    });
  }
  var option = state.matches.find(function (candidate) {
    return candidate.id === state.highlightedId;
  });
  return Object.assign({}, state, {
    isOpen: false,
    highlightedId: null,
    closeReason: 'confirmed',
    lastConfirmedValue: option.label,
    result: {
      type: 'confirmed',
      option: option
    }
  });
}

// Confirms whichever option was clicked, not just the keyboard-highlighted
// one - a mouse user can click any visible option directly, so this mirrors
// onEnter's confirm branch without requiring it to already be highlighted.
function onOptionClick(state, _ref3) {
  var option = _ref3.option;
  return Object.assign({}, state, {
    isOpen: false,
    highlightedId: null,
    highlightCleared: false,
    closeReason: 'confirmed',
    lastConfirmedValue: option.label,
    result: {
      type: 'confirmed',
      option: option
    }
  });
}

// Typing an option's text and leaving the field (or submitting) accepts it,
// the same as choosing it from the list - recorded as confirmed so Escape
// treats it like any other confirmed choice.
function onAcceptMatch(state, _ref4) {
  var option = _ref4.option;
  return Object.assign({}, state, {
    isOpen: false,
    highlightedId: null,
    highlightCleared: false,
    closeReason: 'confirmed',
    lastConfirmedValue: option.label
  });
}

// First Escape: closes the list, focus stays put. Second Escape: clears the
// text, but only if the list is closed because it was dismissed and the text
// was never confirmed - checking closeReason alone isn't enough, since
// re-opening a confirmed value (ArrowDown) and dismissing it again would
// otherwise let the next Escape wipe out the confirmed choice.
function onEscape(state) {
  if (state.isOpen) {
    return Object.assign({}, state, {
      isOpen: false,
      highlightedId: null,
      highlightCleared: false,
      closeReason: 'dismissed',
      result: {
        type: 'closed'
      }
    });
  }
  if (state.closeReason === 'dismissed' && state.lastConfirmedValue === null) {
    // Same filter state as typing into an empty field, so nothing from the
    // abandoned query (matches, count) survives into the next ArrowDown.
    return Object.assign({}, state, {
      closeReason: null,
      status: 'belowThreshold',
      matches: [],
      matchCount: 0,
      result: {
        type: 'cleared'
      }
    });
  }
  return Object.assign({}, state, {
    result: {
      type: 'noop'
    }
  });
}

// Home, End, and anything else this component doesn't own. The adapter must
// not call preventDefault() on an 'unhandled' result, so native behaviour
// (e.g. text-cursor movement) keeps working.
function onUnhandledKey(state) {
  return Object.assign({}, state, {
    result: {
      type: 'unhandled'
    }
  });
}
module.exports = {
  createInitialState: createInitialState,
  onType: onType,
  onRequestFullList: onRequestFullList,
  onArrowDown: onArrowDown,
  onArrowUp: onArrowUp,
  onEnter: onEnter,
  onOptionClick: onOptionClick,
  onAcceptMatch: onAcceptMatch,
  onEscape: onEscape,
  onUnhandledKey: onUnhandledKey
};

/***/ }),

/***/ 1:
/***/ (function(module) {

// Removes case, space and accent differences before comparing, so "N37E3"
// finds "N37 E300" and "Beal" finds "Béal". Decomposes accented letters (NFD)
// and drops the combining marks - a code-point range rather than \p{M}, which
// needs a newer regex engine.
function normalize(text) {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '');
}

// Does optionLabel match query, using the given mode?
function isMatch(optionLabel, query, mode) {
  var normalizedQuery = normalize(query);
  if (!normalizedQuery) {
    return false;
  }
  var normalizedOption = normalize(optionLabel);
  return mode === 'contains' ? normalizedOption.includes(normalizedQuery) : normalizedOption.startsWith(normalizedQuery);
}

// Filters options against a query, respecting the minimum character threshold.
// options: Array<{ id: string, label: string }>
// mode: 'start' | 'contains'
function filterOptions(_ref) {
  var options = _ref.options,
    query = _ref.query,
    mode = _ref.mode,
    minChars = _ref.minChars;
  // Counts the characters that will actually be matched, so internal spaces
  // ("a b") don't count towards the threshold.
  if (normalize(query).length < minChars) {
    return {
      status: 'belowThreshold',
      matches: [],
      matchCount: 0
    };
  }
  var matches = options.filter(function (option) {
    return isMatch(option.label, query, mode);
  });
  return {
    status: matches.length > 0 ? 'hasMatches' : 'noMatches',
    matches: matches,
    matchCount: matches.length
  };
}
module.exports = {
  normalize: normalize,
  isMatch: isMatch,
  filterOptions: filterOptions
};

/***/ }),

/***/ 277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleAttribute = _require.toggleAttribute;

/**
 * Ensure details component is cross browser and accessible
 * Test at http://localhost:3001/hse-frontend/components/details/index.html
 */

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Does the browser support details component
  var nativeSupport = typeof document.createElement('details').open === 'boolean';
  if (nativeSupport) {
    return;
  }

  // Nodelist of all details elements
  var allDetails = scope.querySelectorAll('details');

  /**
   * Adds all necessary functionality to a details element
   * @param {HTMLElement} element details element to initialise
   * @param {number} index number to be appended to dynamic IDs
   */
  var initDetails = function initDetails(element, index) {
    // Set details element as polyfilled to prevent duplicate events being added
    element.setAttribute('hse-polyfilled', 'true');

    // Give details element an ID if it doesn't already have one
    if (!element.id) element.setAttribute('id', "hse-details" + index);

    // Set content element and give it an ID if it doesn't already have one
    var content = scope.querySelector("#" + element.id + " .hse-details__text");
    if (!content.id) content.setAttribute('id', "hse-details__text" + index);

    // Set summary element
    var summary = scope.querySelector("#" + element.id + " .hse-details__summary");

    // Set initial summary aria attributes
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-controls', content.id);
    summary.setAttribute('tabIndex', '0');
    var openAttr = element.getAttribute('open') !== null;
    if (openAttr === true) {
      summary.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    } else {
      summary.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.display = 'none';
    }
    var toggleDetails = function toggleDetails() {
      toggleAttribute(summary, 'aria-expanded');
      toggleAttribute(content, 'aria-hidden');
      content.style.display = content.getAttribute('aria-hidden') === 'true' ? 'none' : '';
      if (element.hasAttribute('open')) {
        element.removeAttribute('open');
      } else {
        element.setAttribute('open', 'open');
      }
    };

    // Toggle details onclick
    summary.addEventListener('click', toggleDetails);

    // Call toggle details on enter and space key events
    summary.addEventListener('keydown', function (event) {
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault();
        summary.click();
      }
    });
  };

  // Initialise details for any new details element
  if (allDetails.length) {
    allDetails.forEach(function (element, index) {
      if (!element.hasAttribute('hse-polyfilled')) initDetails(element, index);
    });
  }
};

/***/ }),

/***/ 484:
/***/ (function(module) {

module.exports = function () {
  var nav = document.getElementById('header-navigation');
  var menuButton = document.getElementById('toggle-menu');
  var translationButton = document.getElementById('translations-desktop-btn');
  var searchButton = document.getElementById('toggle-search');
  var addFocus = function addFocus() {
    var navigationLinksList = nav.getElementsByClassName('hse-header-dropdown__navigation-link');
    var lastLink = navigationLinksList[navigationLinksList.length - 1];
    // eslint-disable-next-line prefer-destructuring
    var firstLink = navigationLinksList[0];
    var _document$getElements = document.getElementsByClassName('hse-header-dropdown__link'),
      logoLink = _document$getElements[0];
    if (nav.classList.contains('js-show')) {
      menuButton.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && nav.classList.contains('js-show')) {
          event.preventDefault();
          menuButton.blur();
          navigationLinksList[0].focus();
        }
        if (event.key === 'Tab' && event.shiftKey && nav.classList.contains('js-show')) {
          menuButton.blur();
          menuButton.click();
          logoLink.focus();
        }
      });
      lastLink.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && !event.shiftKey) {
          event.preventDefault();
          if (translationButton) {
            translationButton.focus();
          } else if (searchButton) {
            searchButton.focus();
          }
          if (nav.classList.contains('js-show')) {
            menuButton.click();
          }
        }
      });
      firstLink.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && event.shiftKey) {
          event.preventDefault();
          firstLink.blur();
          menuButton.focus();
        }
      });
    }
  };
  var toggleEnter = function toggleEnter() {
    menuButton.addEventListener('keyup', function (event) {
      if (event.currentTarget.id === 'toggle-menu') {
        if (event.key === 'Enter') {
          addFocus();
        }
      }
    });
  };
  if (menuButton) toggleEnter();
};

/***/ }),

/***/ 937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var focusToggle = __webpack_require__(484);
var ToggleButtons = __webpack_require__(622);
var ToggleTranslationsMobile = __webpack_require__(754);
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var headerDropdown = scope.querySelector('.hse-header-dropdown');
  if (headerDropdown) {
    ToggleButtons('.hse-header-dropdown__');
    ToggleTranslationsMobile();
    focusToggle('.hse-header-dropdown__');
  }
};

/***/ }),

/***/ 622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleAttribute = _require.toggleAttribute,
  toggleClass = _require.toggleClass;
module.exports = function (sltName) {
  var toggleBtns = document.querySelectorAll(sltName + "toggle-btn");
  var toggle = function toggle(button, container) {
    toggleAttribute(button, 'aria-expanded');
    toggleClass(button, 'is-active');
    toggleClass(container, 'js-show');
  };
  var toggleBtn = function toggleBtn(event) {
    event.preventDefault();
    var button = event.currentTarget;
    var controls = button.getAttribute('aria-controls');
    var container = document.getElementById(controls);
    toggleActive(button);
    toggle(button, container);
  };
  var toggleActive = function toggleActive(activeButton) {
    var activeToggleBtns = document.querySelectorAll(sltName + "toggle-btn.is-active");
    activeToggleBtns.forEach(function (button) {
      var controls = button.getAttribute('aria-controls');
      var container = document.getElementById(controls);
      if (activeButton.id !== button.id) {
        toggle(button, container);
      }
    });
  };
  var addEvents = function addEvents() {
    toggleBtns.forEach(function (elem) {
      elem.addEventListener('click', toggleBtn, false);
    });
    document.addEventListener('click', function (event) {
      var clickedElement = event.target;
      var activeToggleBtn = document.querySelector('.hse-header-dropdown__toggle-btn--translations.is-active');
      if (activeToggleBtn && clickedElement.closest(sltName + "toggle-btn") === null) {
        toggleActive(activeToggleBtn);
        var controls = activeToggleBtn.getAttribute('aria-controls');
        var container = document.getElementById(controls);
        toggle(activeToggleBtn, container);
      }
    });
  };
  if (toggleBtns) addEvents();
};

/***/ }),

/***/ 754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleAttribute = _require.toggleAttribute,
  toggleClass = _require.toggleClass;
module.exports = function () {
  var toggleButton = document.querySelector('#toggle-translations-mobile-btn');
  var container = document.querySelector('#translations-mobile');
  var toggleSearch = function toggleSearch(event) {
    event.preventDefault();
    toggleAttribute(toggleButton, 'aria-expanded');
    toggleClass(toggleButton, 'is-active');
    toggleClass(container, 'js-show');
  };
  var addEvents = function addEvents() {
    ;
    [toggleButton].forEach(function (elem) {
      elem.addEventListener('click', toggleSearch);
    });
  };
  if (toggleButton) addEvents();
};

/***/ }),

/***/ 481:
/***/ (function(module) {

/**
 * Header v3: moves primary links that don't fit into the menu, and opens and
 * closes the menu below desktop. Without JavaScript, or in browsers without
 * Array.from and Array.prototype.findIndex (IE11), every link stays in the
 * bar and the menu stays open.
 * Test at http://localhost:3000/hse-frontend/components/header-v3/prototype.html
 */
var HeaderV3 = /*#__PURE__*/function () {
  function HeaderV3($module) {
    this.$module = $module;
    this.$navRow = $module.querySelector('.hse-header-v3__nav-row');
    this.$menuButton = $module.querySelector('.hse-header-v3__menu-button');
    this.$menu = $module.querySelector('.hse-header-v3__menu');
    this.$menuNav = $module.querySelector('.hse-header-v3__menu-nav');
    this.$barItems = Array.from($module.querySelectorAll('.hse-header-v3__primary-item'));
    this.$menuItems = Array.from($module.querySelectorAll('.hse-header-v3__menu-primary-item'));
  }
  var _proto = HeaderV3.prototype;
  _proto.init = function init() {
    var _this = this;
    if (!this.$navRow || !this.$menuButton || !this.$menu) {
      return;
    }

    // Without JavaScript the Menu button is hidden and the menu is open. The
    // enhanced class switches the bar from wrapping to priority links.
    this.$module.classList.add('hse-header-v3--enhanced');
    this.$menuButton.hidden = false;
    this.setMenuOpen(false);
    this.$menuButton.addEventListener('click', function () {
      _this.setMenuOpen(!_this.isMenuOpen());
    });
    this.$module.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && _this.isMenuOpen()) {
        _this.setMenuOpen(false);
        _this.$menuButton.focus();
      }
    });
    this.updatePriorityLinks();
    if (typeof window.ResizeObserver === 'function') {
      new window.ResizeObserver(function () {
        return _this.updatePriorityLinks();
      }).observe(this.$navRow);
    } else {
      window.addEventListener('resize', function () {
        return _this.updatePriorityLinks();
      });
    }
  };
  _proto.isMenuOpen = function isMenuOpen() {
    return this.$menuButton.getAttribute('aria-expanded') === 'true';
  };
  _proto.setMenuOpen = function setMenuOpen(open) {
    this.$menuButton.setAttribute('aria-expanded', String(open));
    this.$menu.hidden = !open;
  }

  // The Menu button is hidden by CSS from the large-desktop breakpoint, so
  // its visibility tells us which layout is active without repeating the
  // breakpoint here.
;
  _proto.isDesktop = function isDesktop() {
    return window.getComputedStyle(this.$menuButton).display === 'none';
  }

  // Priority links (NHS.UK header pattern): keep links in the bar, in order,
  // until the next one doesn't fit beside the Menu button; the rest show in
  // the menu panel instead.
;
  _proto.updatePriorityLinks = function updatePriorityLinks() {
    this.$barItems.forEach(function ($item) {
      $item.hidden = false;
    });
    var visibleCount = this.$barItems.length;
    if (this.isDesktop()) {
      if (this.isMenuOpen()) {
        this.setMenuOpen(false);
      }
    } else {
      var buttonStyle = window.getComputedStyle(this.$menuButton);
      var available = this.$navRow.clientWidth - this.$menuButton.offsetWidth - (parseFloat(buttonStyle.marginLeft) || 0);
      var used = 0;
      var firstOverflowing = this.$barItems.findIndex(function ($item) {
        used += $item.offsetWidth;
        return used > available;
      });
      if (firstOverflowing !== -1) {
        visibleCount = firstOverflowing;
      }
      this.$barItems.forEach(function ($item, index) {
        $item.hidden = index >= visibleCount;
      });
    }
    this.$menuItems.forEach(function ($item, index) {
      $item.hidden = index < visibleCount;
    });
    if (this.$menuNav) {
      this.$menuNav.hidden = visibleCount === this.$menuItems.length;
    }
  };
  return HeaderV3;
}();
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Browsers without these (IE11) keep the header's no-JavaScript layout:
  // every primary link in the bar and the menu panel open. Without the
  // check, init() throws and stops every component after this one in
  // initAll() from initialising, including Quick exit.
  if (typeof Array.from !== 'function' || typeof Array.prototype.findIndex !== 'function') {
    return;
  }
  var headers = scope.querySelectorAll('[data-module="hse-header-v3"]');
  headers.forEach(function ($module) {
    // initAll(scope) can run again over content it has already seen - a
    // second instance would bind every listener twice.
    if ($module.dataset.headerV3Initialised) {
      return;
    }
    $module.dataset.headerV3Initialised = 'true';
    new HeaderV3($module).init();
  });
};
module.exports.HeaderV3 = HeaderV3;

/***/ }),

/***/ 649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ToggleButtons = __webpack_require__(622);
module.exports = function () {
  var header = document.querySelector('.hse-header');
  if (header) {
    ToggleButtons('.hse-header__');
  }
};

/***/ }),

/***/ 13:
/***/ (function(module) {

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var notifications = scope.querySelectorAll('.hse-notification--dismissable');
  var addEvents = function addEvents() {
    notifications.forEach(function (elem) {
      var closeButton = elem.querySelector('.hse-notification__close-btn');
      closeButton.addEventListener('click', function () {
        elem.remove();
      });
    });
  };
  if (notifications) addEvents();
};

/***/ }),

/***/ 143:
/***/ (function(module) {

var REQUIRED_PRESSES = 3;
var RESET_DELAY_MS = 5000;
var LARGE_DESKTOP_BREAKPOINT = 990;
var SR_MESSAGES = ['', 'Press Shift 2 more times to hide this page', 'Press Shift 1 more time to hide this page'];
module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope,
    navigate = _ref.navigate;
  var quickExits = scope.querySelectorAll('.hse-quick-exit');
  if (!quickExits.length) {
    return function () {};
  }
  var doNavigate = navigate || function (url) {
    return window.location.assign(url);
  };
  var cleanups = [];
  quickExits.forEach(function (container) {
    var exitLink = container.querySelector('.hse-button');
    var liveRegion = container.querySelector('[role="status"]');
    if (!exitLink || !liveRegion) {
      return;
    }
    var exitUrl = exitLink.getAttribute('href');
    var shiftCount = 0;
    var resetTimer = null;
    var reset = function reset() {
      shiftCount = 0;
      clearTimeout(resetTimer);
      liveRegion.textContent = '';
    };
    var handleKeyUp = function handleKeyUp(event) {
      if (!document.body.contains(container)) {
        return;
      }
      if (event.key !== 'Shift') {
        reset();
        return;
      }
      if (event.ctrlKey || event.altKey || event.metaKey) {
        return;
      }
      clearTimeout(resetTimer);
      shiftCount += 1;
      if (shiftCount >= REQUIRED_PRESSES) {
        liveRegion.textContent = 'Leaving this page';
        shiftCount = 0;
        clearTimeout(resetTimer);
        doNavigate(exitUrl);
        return;
      }
      liveRegion.textContent = SR_MESSAGES[shiftCount];
      resetTimer = setTimeout(reset, RESET_DELAY_MS);
    };
    var handlePageShow = function handlePageShow() {
      if (!document.body.contains(container)) {
        return;
      }
      reset();
    };
    document.addEventListener('keyup', handleKeyUp);
    window.addEventListener('pageshow', handlePageShow);
    cleanups.push(function () {
      clearTimeout(resetTimer);
      document.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('pageshow', handlePageShow);
    });
  });
  var updateBodyPadding = function updateBodyPadding() {
    if (window.innerWidth >= LARGE_DESKTOP_BREAKPOINT) {
      document.body.style.removeProperty('padding-bottom');
      return;
    }
    document.body.style.paddingBottom = quickExits[0].offsetHeight + "px";
  };
  updateBodyPadding();
  window.addEventListener('resize', updateBodyPadding);
  cleanups.push(function () {
    window.removeEventListener('resize', updateBodyPadding);
    document.body.style.removeProperty('padding-bottom');
  });
  return function () {
    return cleanups.forEach(function (fn) {
      return fn();
    });
  };
};

/***/ }),

/***/ 551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  toggleConditionalInput = _require.toggleConditionalInput;

/**
 * Conditionally show content when a radio button is checked
 * Test at http://localhost:3001/hse-frontend/components/radios/conditional.html
 */

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  // Radio input HTMLElements inside a conditional form group
  var radioInputs = scope.querySelectorAll('.hse-radios--conditional .hse-radios__input');

  /**
   * Update all conditional reveals to match checked state
   */
  var syncAllConditionalReveals = function syncAllConditionalReveals() {
    radioInputs.forEach(function (input) {
      return toggleConditionalInput(input, 'hse-radios__conditional--hidden');
    });
  };

  // When the page is restored after navigating 'back' in some browsers the
  // state of form controls is not restored until *after* the DOMContentLoaded
  // event is fired, so we need to sync after the pageshow event in browsers
  // that support it.
  if ('onpageshow' in window) {
    window.addEventListener('pageshow', syncAllConditionalReveals);
  } else {
    window.addEventListener('DOMContentLoaded', syncAllConditionalReveals);
  }

  // Although we've set up handlers to sync state on the pageshow or
  // DOMContentLoaded event, init could be called after those events have fired,
  // for example if they are added to the page dynamically, so sync now too.
  syncAllConditionalReveals();

  // Attach event handler to radioInputs
  radioInputs.forEach(function (radioButton) {
    radioButton.addEventListener('change', syncAllConditionalReveals);
  });
};

/***/ }),

/***/ 829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _require = __webpack_require__(848),
  setFocus = _require.setFocus;

/*
 * HSE.IE skip link.
 *
 * When using VoiceOver on iOS, focus remains on the skip link anchor
 * when elected so the next focusable element is not at the jumped to area.
 */

module.exports = function () {
  var $skipLink = document.querySelector('.hse-skip-link');

  // Check for skip link
  if (!$skipLink || !($skipLink instanceof HTMLAnchorElement)) {
    return;
  }
  var linkedElementId = $skipLink.hash.split('#').pop();
  var $linkedElement = linkedElementId ? document.getElementById(linkedElementId) : null;

  // Check for linked element
  if (!$linkedElement) {
    return;
  }

  /**
   * Focus the linked element on click
   *
   * Adds a helper CSS class to hide native focus styles,
   * but removes it on blur to restore native focus styles
   */
  $skipLink.addEventListener('click', function () {
    return setFocus($linkedElement, {
      onBeforeFocus: function onBeforeFocus() {
        $linkedElement.classList.add('hse-skip-link-focused-element');
      },
      onBlur: function onBlur() {
        $linkedElement.classList.remove('hse-skip-link-focused-element');
      }
    });
  });
};

/***/ }),

/***/ 969:
/***/ (function(module) {

module.exports = function (_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? document : _ref$scope;
  var allComponents = scope.querySelectorAll('.hse-step-by-step');
  if (!allComponents.length) {
    return;
  }
  var updateStepState = function updateStepState(toggle, panel, isOpen) {
    var label = toggle.querySelector('.hse-step-by-step__step-toggle-label');
    var showLabel = toggle.getAttribute('data-show-label') || 'Show';
    var hideLabel = toggle.getAttribute('data-hide-label') || 'Hide';
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    label.textContent = isOpen ? hideLabel : showLabel;
    if (isOpen) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', 'hidden');
    }
  };
  var updateGlobalState = function updateGlobalState(container) {
    var globalToggle = container.querySelector('.hse-step-by-step__toggle-all');
    var globalLabel = container.querySelector('.hse-step-by-step__toggle-all-label');
    var stepToggles = container.querySelectorAll('.hse-step-by-step__step-toggle');
    var allOpen = Array.from(stepToggles).every(function (toggle) {
      return toggle.getAttribute('aria-expanded') === 'true';
    });
    var showAllLabel = globalToggle.getAttribute('data-show-all-label') || 'Show all steps';
    var closeAllLabel = globalToggle.getAttribute('data-close-all-label') || 'Close all steps';
    globalToggle.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
    globalLabel.textContent = allOpen ? closeAllLabel : showAllLabel;
  };
  var toggleAllSteps = function toggleAllSteps(container, shouldOpen) {
    container.querySelectorAll('.hse-step-by-step__step-toggle').forEach(function (toggle) {
      var panel = container.querySelector("#" + toggle.getAttribute('aria-controls'));
      updateStepState(toggle, panel, shouldOpen);
    });
    updateGlobalState(container);
  };
  allComponents.forEach(function (container) {
    var globalToggle = container.querySelector('.hse-step-by-step__toggle-all');
    var stepToggles = container.querySelectorAll('.hse-step-by-step__step-toggle');
    stepToggles.forEach(function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = container.querySelector("#" + panelId);
      var header = toggle.closest('.hse-step-by-step__step-header');
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') !== 'true';
        updateStepState(toggle, panel, isOpen);
        updateGlobalState(container);
      });
      toggle.addEventListener('focus', function () {
        var stepEl = toggle.closest('.hse-step-by-step__step');
        if (stepEl) stepEl.classList.add('hse-step-by-step__step--focused');
      });
      toggle.addEventListener('blur', function () {
        var stepEl = toggle.closest('.hse-step-by-step__step');
        if (stepEl) stepEl.classList.remove('hse-step-by-step__step--focused');
      });
      if (header) {
        header.addEventListener('click', function (e) {
          if (!toggle.contains(e.target) && e.target !== toggle) {
            toggle.click();
            toggle.focus();
          }
        });
      }
      var stepEl = toggle.closest('.hse-step-by-step__step');
      var marker = stepEl ? stepEl.querySelector('.hse-step-by-step__step-marker') : null;
      if (marker) {
        marker.addEventListener('click', function () {
          toggle.click();
          toggle.focus();
        });
      }
    });
    globalToggle.addEventListener('click', function () {
      var shouldOpen = globalToggle.getAttribute('aria-expanded') !== 'true';
      toggleAllSteps(container, shouldOpen);
    });
    updateGlobalState(container);
  });
};

/***/ }),

/***/ 265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable import/prefer-default-export */

// Components
var initCharacterCount = __webpack_require__(997);
var initCheckboxes = __webpack_require__(305);
var initCombobox = __webpack_require__(365);
var initDetails = __webpack_require__(277);
var initHeader = __webpack_require__(649);
var initHeaderDropdown = __webpack_require__(937);
var initHeaderV3 = __webpack_require__(481);
var initNotification = __webpack_require__(13);
var initQuickExit = __webpack_require__(143);
var initRadios = __webpack_require__(551);
var initSkipLink = __webpack_require__(829);
var initStepByStep = __webpack_require__(969);
__webpack_require__(621);

/**
 * Use this function to initialise hse-frontend components within a
 * given scope. This function is called by default with the document
 * element, but you can call it again later with a new DOM element
 * containing hse-frontend components which you wish to initialise.
 *
 * @param {HTMLElement} scope
 */
function initAll(scope) {
  initCharacterCount({
    scope: scope
  });
  initCheckboxes({
    scope: scope
  });
  initCombobox({
    scope: scope
  });
  initDetails({
    scope: scope
  });
  initRadios({
    scope: scope
  });
  initNotification({
    scope: scope
  });
  initHeaderDropdown({
    scope: scope
  });
  initHeaderV3({
    scope: scope
  });
  initQuickExit({
    scope: scope
  });
  initStepByStep({
    scope: scope
  });
}

// Initialize components
document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initSkipLink();
  initAll(document);
});
module.exports = {
  initAll: initAll
};

/***/ }),

/***/ 621:
/***/ (function() {

/**
 * IE polyfill for NodeList.forEach()
 */
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * IE polyfill for Array.includes()
 */
if (!Array.prototype.includes) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'includes', {
    enumerable: false,
    value: function value(obj) {
      return this.filter(function (el) {
        return el === obj;
      }).length > 0;
    }
  });
}

/**
 * IE polyfill for Element.closest()
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;
    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

/**
 * IE polyfill for CustomEvent
 */
if (typeof window.CustomEvent !== 'function') {
  window.CustomEvent = function (event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(265);
/******/ 	
/******/ })()
;
